import { combineReducers } from 'redux';
import formData from './reducers/form_data';
import availablePages from './reducers/available_pages';

export default combineReducers({
  formData,
  availablePages
});
